import { makeApiUrl, makeHttpClient } from '~/main/factories/http';
import { GuestAppointment as UsecaseRemoteGuestAppointment } from '~/domain/usecases/appointment/remote';

import { RemoteGuestAppointment } from '~/data/repository/appointment';

/**
 * send request via API.
 */
export const makeRemoteGuestAppointment = (): UsecaseRemoteGuestAppointment =>
  new RemoteGuestAppointment(
    makeApiUrl('/appointments/guest'),
    makeHttpClient(),
  );
